import React, { useCallback, useRef, useState } from 'react'
import styles from './style.module.scss'
import Fixtures from './fixtures'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import MwebFixtures from './mwebFixtures'

const tabs = ['All', 'Live', 'Finished', 'Scheduled']

function IPLMatches({ fixture, isMobile = false }) {
  const [activeTab, setActiveTab] = useState('All')
  const router = useRouter()

  const getFilterMatches = useCallback(
    (data, tab) => {
      if (tab === 'All') {
        const completedMatches = data.filter((match) => match.sStatusStr === 'completed')
        const scheduledMatches = data.filter((match) => match.sStatusStr === 'scheduled')

        const lastTwoCompleted = completedMatches.slice(-2)

        return [...lastTwoCompleted, ...scheduledMatches]
      } else if (tab === 'Scheduled') {
        return data?.filter((match) => match.sStatusStr === 'scheduled')
      } else if (tab === 'Live') {
        return data?.filter((match) => match.sStatusStr === 'live')
      } else if (tab === 'Finished') {
        return data?.filter((match) => match.sStatusStr === 'completed')
      } else {
        return data
      }
    },
    [activeTab]
  )

  const filteredFixtures = useRef(getFilterMatches(fixture, activeTab))
  const liveMatches = getFilterMatches(fixture, 'Live')

  return (
    <div className='d-flex flex-column mt-2'>
      <h4>Matches</h4>
      <div className={styles.tabList}>
        {tabs
          .filter((tab) => tab !== 'Live' || liveMatches.length > 0)
          .map((tab, i) => (
            <button
              key={i}
              className={` ${styles.tabs} ${activeTab === tab ? styles.activeTab : ''}`}
              onClick={() => {
                filteredFixtures.current = getFilterMatches(fixture, tab)
                setActiveTab(tab)
              }}
            >
              <span>{tab}</span>
            </button>
          ))}
      </div>
      <div className='mt-4'>
        {router.pathname === '/ipl-indian-premier-league-2025/mobile' ? (
          <MwebFixtures
            fixture={filteredFixtures.current}
            filterFn={getFilterMatches}
            activeTab={activeTab}
          />
        ) : (
          <Fixtures
            fixture={filteredFixtures.current}
            filterFn={getFilterMatches}
            activeTab={activeTab}
          />
        )}
      </div>
    </div>
  )
}

IPLMatches.propTypes = {
  fixture: PropTypes.array,
  isMobile: PropTypes.bool
}

export default IPLMatches
